<div class="row">

  <div class="col-md-6">
    <h2 class="text-primary"><i class="fa fa-users"></i> Clients </h2>
  </div>

  <div class="col-md-6">
    <h5 class="text-right text-primary"> TotalOwed : {{totalOwed | currency:'INR':'symbol'}}</h5>
  </div>

</div>

<table *ngIf="clients?.length > 0 " class=" table table-striped">
  <thead class="thead-inverse">
    <tr>
      <th> Name </th>
      <th> Email </th>
      <th> Balance </th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let client of clients">
      <td> {{client.firstName}} {{client.lastName}} </td>
      <td> {{client.email}} </td>
      <td> {{client.balance | currency:'INR' : 'symbol'}} </td>
      <td> <a routerLink="client/{{ client.id }}" class="btn btn-info btn-sm">
          <i class="fa fa-arrow-circle-o-right"></i> Details </a> </td>
    </tr>
  </tbody>

</table>
<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>




<!-- <ng-template #noClients>
  <hr>
  <h5>There is no Clients in the system</h5>
</ng-template> -->